import Vue from 'vue';

Vue.component('profile-index', () =>
    import(/* webpackChunkName: 'profile-index' */ './profile-index.vue'),
);
